import React from "react";
import { liveKey, oddsHoldText } from "./useInPlayOdds";

const oddsSize = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value);
  return Number.isFinite(n) ? n : "";
};

const inRange = (limit, price) => {
  const p = Number(price);
  if (!Number.isFinite(p) || p <= 0) return false;
  if (!limit || limit.min == null || limit.max == null) return Number.isFinite(p);
  return Number(limit.min) <= p && Number(limit.max) >= p;
};

/**
 * "Match Odds" block for one match in the Sports list.
 *
 * - liveEnabled=false (Today / Tomorrow): static REST odds, not clickable.
 * - liveEnabled=true  (In-Play): socket odds, clickable only while the match is
 *   present in the latest GET_INPLAY_MATCHES payload.
 */
const InPlayOddsTable = ({
  item,
  sportType,
  liveEnabled,
  liveOdds,
  oddsFlash,
  clickedBet,
  clickedTableData,
  onBet,
}) => {
  const key = liveKey(item);
  const live = liveEnabled ? liveOdds[key] : undefined;

  const [team1, team2] = (item?.eventName || "").split(" v ");
  const fallbackRows = [
    { nat: team1, b1: item.back1, bs1: item.backSize1, l1: item.lay1, ls1: item.laySize1 },
    { nat: team2, b1: item.back3, bs1: item.backSize3, l1: item.lay3, ls1: item.laySize3 },
  ];
  if (item?.RunnersNumber > 2) {
    fallbackRows.push({
      nat: "The Draw",
      b1: item.back2,
      bs1: item.backSize2,
      l1: item.lay2,
      ls1: item.laySize2,
    });
  }

  const rows = live && live.t1.length ? live.t1 : fallbackRows;
  const hasPrices = rows.some((r) => Number(r?.b1) > 0 || Number(r?.l1) > 0);
  if (!hasPrices) return null;
  const priceLimit = live?.bet_odds_limit;
  const stakeLimit = live?.bet_odds_limit;
  const maxPrice = Number(stakeLimit?.maxPrice) || 0;
  const matched = (live?.t1 || item?.t1 || [])[0]?.totalmatch;
  const showStakeLimit =
    stakeLimit && (Number.isFinite(Number(stakeLimit.min)) || Number.isFinite(Number(stakeLimit.max)));

  return (
    <div className="sports-team-table" onClick={(e) => e.stopPropagation()}>
      <div className="match-odd-table bg-white px-0 pt-1">
        <div className="d-flex back-lay-head justify-content-end ms-auto pb-1 bg-yellow w-100">
          <div
            className="half-table"
            style={{ color: "var(--colorSecond)", borderRight: "1px solid var(--colorSecond)" }}
          >
            <h4 className="text-left">Match Odds</h4>
            {matched && (
              <span style={{ fontSize: "10.4px", paddingLeft: "0.5rem" }}>
                Matched <span style={{ fontWeight: 700 }}>{matched}</span>
              </span>
            )}
          </div>
          <span className="text-center half-table-text" style={{ width: "64px" }}>Back</span>
          <span className="text-center half-table-text" style={{ width: "64px" }}>Lay</span>
        </div>

        <ul className="mb-1 rounded position-relative p-0">
          {rows.map((runner, idx) => {
            const flashId = `${key}-${runner?.sId ?? idx}`;
            const hold = !live
              ? ""
              : live.suspend?.odds === true || live.suspended === true
                ? "Suspended"
                : oddsHoldText(runner?.status);
            const sideOver = (price) => maxPrice > 0 && Number(price) > maxPrice;
            const backOver = !hold && sideOver(runner?.b1);
            const layOver = !hold && sideOver(runner?.l1);
            const backOk = Boolean(live) && !hold && !backOver && inRange(priceLimit, runner?.b1);
            const layOk = Boolean(live) && !hold && !layOver && inRange(priceLimit, runner?.l1);
            const isRunner = (side) =>
              clickedBet?.sId === runner?.sId && clickedTableData === side;

            return (
              <li key={runner?.sId ?? idx}>
                <h2>{runner?.nat}</h2>
                <div className="lay-back-table" style={{ position: "relative", gap: "3px" }}>
                  <div
                    className={`back${oddsFlash[`${flashId}:back`] ? " spark-back" : ""}${isRunner("b1") ? " back-active" : ""
                      }`}
                    onClick={(e) => onBet(e, runner, "b1", item, sportType)}
                    style={{ position: "relative", cursor: backOk ? "pointer" : "default", marginRight: 0 }}
                  >
                    <span>
                      <strong>{runner?.b1}</strong>
                      <span className="d-block">{oddsSize(runner?.bs1)}</span>
                    </span>
                    {/* {backOver && (
                      <div
                        className="maxprice-exceeded"
                        style={{
                          position: "absolute",
                          inset: 0,
                          background: "#6f8898",
                          opacity: 0.8,
                          pointerEvents: "none",
                        }}
                      />
                    )} */}
                  </div>
                  <div
                    className={`lay${oddsFlash[`${flashId}:lay`] ? " spark-lay" : ""}${isRunner("l1") ? " lay-active" : ""
                      }`}
                    onClick={(e) => onBet(e, runner, "l1", item, sportType)}
                    style={{ position: "relative", cursor: layOk ? "pointer" : "default", marginRight: 0 }}
                  >
                    <span>
                      <strong>{runner?.l1}</strong>
                      <span className="d-block">{oddsSize(runner?.ls1)}</span>
                    </span>
                    {/* {layOver && (
                      <div
                        className="maxprice-exceeded"
                        style={{
                          position: "absolute",
                          inset: 0,
                          background: "#6f8898",
                          opacity: 0.8,
                          pointerEvents: "none",
                        }}
                      />
                    )} */}
                  </div>

                  {(backOver || layOver) && (
                    <div
                      className="maxprice-exceeded"
                      style={{
                        width: "100%",
                        position: "absolute",
                        inset: 0,
                        background: "#6f8898",
                        opacity: 0.8,
                        pointerEvents: "none",
                      }}
                    />
                  )}

                  {live && hold && (
                    <div
                      className="overlay-match"
                      style={{
                        position: "absolute",
                        inset: 0,
                        zIndex: 6,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#6f8898",
                        color: "#fff",
                        opacity: 0.8,
                        borderRadius: 6,
                        fontSize: 12,
                        pointerEvents: "none",
                      }}
                    >
                      {hold}
                    </div>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
        {/* {live && showStakeLimit && (
          <div className="market-depth-sec d-flex justify-content-end pt-1 px-2">
            <div className="d-flex align-items-center min-max">
              <span style={{ fontWeight: 600 }}>Min/Max</span>
              <strong style={{ fontWeight: 600 }}>
                {stakeLimit.min}/{stakeLimit.max}
              </strong>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default InPlayOddsTable;
